import React, { useCallback, useEffect, useState } from 'react';

import { Modal } from 'components';
import { AnsweringServiceSettings } from './components';

type AnsweringServiceSettingsProps = {
  fetchSettings: () => Promise<{ useAppointmentDesk?: boolean }>;
  updateSettings: (value: { useAppointmentDesk: boolean }) => void;
};

export const AnsweringServiceSettingsContainer = (
  props: AnsweringServiceSettingsProps,
) => {
  const { fetchSettings, updateSettings } = props;
  const [loading, setLoading] = useState<boolean>(false);
  const [settings, setSettings] = useState<
    undefined | { useAppointmentDesk: boolean; answeringServicePhone?: string }
  >(undefined);

  const loadSettings = useCallback(async () => {
    setLoading(true);
    const fetchedSettings = await fetchSettings();
    if (fetchedSettings)
      setSettings({
        ...fetchedSettings,
        useAppointmentDesk: fetchedSettings.useAppointmentDesk !== false,
      });
    setLoading(false);
  }, [setLoading, setSettings, fetchSettings]);

  useEffect(() => {
    loadSettings();
  }, [loadSettings]);

  const handleToggleUseAppointmentDesk = useCallback(() => {
    if (settings?.useAppointmentDesk) {
      Modal.confirm({
        title: (
          <>
            Are you sure you’d like to turn off live concierge services for this
            listing?
          </>
        ),
        okText: 'Yes',
        async onOk() {
          updateSettings({ useAppointmentDesk: false });
        },
      });
    } else {
      updateSettings({ useAppointmentDesk: true });
    }
  }, [settings, loadSettings, updateSettings]);

  if (loading || !settings) {
    return null;
  }

  return (
    <AnsweringServiceSettings
      useAppointmentDesk={settings.useAppointmentDesk}
      onToggleUseAppointmentDesk={handleToggleUseAppointmentDesk}
      answeringServicePhone={settings.answeringServicePhone}
    />
  );
};
